import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAttivitaOpen, setIsAttivitaOpen] = useState(false);

  const navigationItems = [
    { name: "HOME", href: "/" },
    { name: "CHI SIAMO", href: "/chi-siamo" },
    {
      name: "ATTIVITÀ",
      href: "#",
      hasDropdown: true,
      submenu: [
        { name: "PROGETTAZIONE", href: "/progettazione" },
        { name: "PRODUZIONE", href: "/produzione" },
      ],
    },
    { name: "QUALITÀ", href: "/qualita" },
    { name: "ELPA", href: "/elpa" },
    /*
    { name: "PRODOTTI", href: "/prodotti" },
     */
    { name: "CLIENTI", href: "/clienti" },
  ];

  return (
    <header className="relative z-20">
      {/* Top contact bar */}
      <div className="py-2 text-white bg-[#4a4a4a]">
        <div className="container flex justify-between items-center px-4 mx-auto text-sm">
          <div className="flex items-center space-x-2 md:space-x-4">
            <span className="flex items-center">
              <svg
                className="mr-1 w-4 h-4"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
              </svg>
              <span className="hidden sm:inline">+39 011 9241104</span>
              <span className="sm:hidden">+39 011 9241104</span>
            </span>
            <span className="flex items-center">
              <svg
                className="mr-1 w-4 h-4"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
              </svg>
              <span className="hidden sm:inline">info@comestsrl.eu</span>
              <span className="sm:hidden">Email</span>
            </span>
          </div>
          <div className="flex hidden items-center">
            <button className="text-red-500">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Main navigation bar */}
      <div className="text-white bg-[#3b5998]">
        <div className="container px-4 py-4 mx-auto">
          <div className="flex justify-between items-center">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img src="/images/logo.png" alt="CO.ME.ST. S.r.l. Logo" className="h-12" />
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:block">
              <ul className="flex space-x-6">
                {navigationItems.map((item) => (
                  <li key={item.name} className="relative group">
                    <a
                      href={item.href}
                      className="flex items-center text-sm font-medium text-white hover:text-gray-200"
                    >
                      {item.name}
                      {item.hasDropdown && (
                        <svg
                          className="ml-1 w-3 h-3"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      )}
                    </a>
                    {item.hasDropdown && item.submenu && (
                      <ul className="overflow-hidden absolute left-0 invisible mt-2 w-48 text-black bg-white rounded-md shadow-lg opacity-0 transition-all duration-300 group-hover:opacity-100 group-hover:visible">
                        {item.submenu.map((subItem, index) => (
                          <li
                            key={subItem.name}
                            className={`hover:bg-gray-100 ${
                              index < item.submenu.length - 1
                                ? "border-b border-gray-200"
                                : ""
                            }`}
                          >
                            <a
                              href={subItem.href}
                              className="block px-4 py-2 text-sm"
                            >
                              {subItem.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </nav>

            {/* Mobile menu button */}
            <button
              className="p-2 text-white lg:hidden"
              onClick={() => setIsMobileMenuOpen(true)}
              aria-label="Toggle mobile menu"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Full-screen Mobile Navigation */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-50 flex flex-col text-white bg-[#3b5998] lg:hidden">
          {/* Mobile Menu Header */}
          <div className="container px-4 py-4 mx-auto">
            <div className="flex justify-between items-center">
              {/* Logo */}
              <Link to="/" className="flex items-center" onClick={() => setIsMobileMenuOpen(false)}>
                <img src="/images/logo.png" alt="CO.ME.ST. S.r.l. Logo" className="h-12" />
              </Link>

              {/* Close Button */}
              <button
                className="p-2 text-white"
                onClick={() => setIsMobileMenuOpen(false)}
                aria-label="Close mobile menu"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
          <hr className="border-blue-800" />

          {/* Mobile Menu Body */}
          <div className="flex flex-col flex-grow justify-center items-center">
            <nav>
              <ul className="space-y-8 text-xl text-center">
                {navigationItems.map((item) => (
                  <li key={item.name}>
                    {item.hasDropdown ? (
                      <div>
                        <button
                          className="flex justify-center items-center w-full"
                          onClick={() =>
                            item.name === "ATTIVITÀ" &&
                            setIsAttivitaOpen(!isAttivitaOpen)
                          }
                        >
                          <span>{item.name}</span>
                          <svg
                            className={`ml-2 w-4 h-4 transform transition-transform ${
                              isAttivitaOpen ? "rotate-180" : ""}`}
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                        {isAttivitaOpen && item.submenu && (
                          <ul className="mt-4 space-y-4 text-lg">
                            {item.submenu.map((subItem) => (
                              <li key={subItem.name}>
                                <a
                                  href={subItem.href}
                                  onClick={() => setIsMobileMenuOpen(false)}
                                  className="hover:text-gray-200"
                                >
                                  {subItem.name}
                                </a>
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ) : (
                      <a
                        href={item.href}
                        onClick={() => setIsMobileMenuOpen(false)}
                        className="hover:text-gray-200"
                      >
                        {item.name}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
